import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
var selectStatesDomain = function (state) {
    return (state && state.states) || getInitialState();
};
export var selectState = createSelector(selectStatesDomain, function (state) { return state; });
